import React, { FC } from "react";
import styled from "styled-components";
import { FontColor, FontWeight, HeadingType, theme } from "../config/theme";

type StyledHeadingProps = {
  type?:         HeadingType;
  show?:         HeadingType;
  color?:        FontColor | string;
  weight?:       FontWeight;
  size?:         HeadingType;
  marginBottom?: string;
};

const StyledHeading = styled.h1<StyledHeadingProps>`
  display:        flex;
  color:          ${(p) => p.color in theme.font.color ? `${theme.font.color[p.color as FontColor]}` : p.color || `${theme.font.color.black}`};
  margin-bottom:  ${(p) => p.marginBottom};
  flex-direction: row;
  gap:            1rem;
  ${p => (theme.font.heading[p.type])}
`

type HeadingProps = {
  type?:         HeadingType;
  size?:         HeadingType;
  text?:         string;
  color?:        FontColor | string;
  weight?:       FontWeight;
  children?:     React.ReactNode;
  marginBottom?: string;
  style?:        any;
};

export const Heading: FC<HeadingProps> = props => (
  <StyledHeading as={props.type} {...props} />
);
